import StoreTemplate from '@/templates/Store.template'

export default function withStoreLayout(PageComponent) {
    return function WrappedComponent(props) {
        return (
            <StoreTemplate>
                <PageComponent {...props} />
            </StoreTemplate>
        )
    }
}
